import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared';
import { SimulationListComponent } from './simulation-list/simulation-list.component';
import { SimulationContainer } from './containers';
import { MatDialogModule } from '@angular/material/dialog';
import { AddSimulationFormComponent } from './simulation-list/dialog/add-simulation-form.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
// Needs to import the BrowserAnimationsModule
import { ParticipantsFormComponent } from './simulation-list/dialog/participants-form.component';
import { AddSimulationTypeFormComponent } from './simulation-list/dialog/add-simulation-type-form.component';
import { StartSimulationFormComponent } from './simulation-list/dialog/start-simulation-form.component';
import { SimulationParticipantService, SimulationService } from './services';
import { NgxPaginationModule } from 'ngx-pagination';
import { TranslateModule } from '@ngx-translate/core';

const SimulationComponent = [
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    TranslateModule,
];

const ProvidersSimulationService = [SimulationService, SimulationParticipantService];

@NgModule({
    imports: [CommonModule, SharedModule, ...SimulationComponent],
    declarations: [
        SimulationListComponent,
        SimulationContainer,
        AddSimulationFormComponent,
        ParticipantsFormComponent,
        AddSimulationTypeFormComponent,
        StartSimulationFormComponent,
    ],
    providers: [...ProvidersSimulationService],
    exports: [CommonModule, SimulationListComponent, SimulationContainer, SharedModule],
})
export class SimulationLazyModule {}
